import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgIspLogoPrimaryBox = (props)=>{
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#C0200D",
        d: "M37.319 40H2.683A2.68 2.68 0 0 1 0 37.319V2.68A2.683 2.683 0 0 1 2.683 0H37.32A2.68 2.68 0 0 1 40 2.681V37.32A2.68 2.68 0 0 1 37.319 40"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M30.413 30.558h-19.99v2.168h19.99zM23.76 13.832v6.667h6.667v6.665h-20V20.5h6.666v-6.667h-6.665V7.167h6.665a6.666 6.666 0 0 1 6.667 6.665"
    }));
};
export default SvgIspLogoPrimaryBox;
